import { Card, CardContent } from "@/components/ui-kit/card";
import { Button } from "@/components/ui-kit/button";
import { Wrench } from "lucide-react";
import { Skeleton } from "@/components/ui-kit/skeleton";
import { useTranslation } from "react-i18next";

type NoToolsProps = {
  onAddClick?: () => void;
  isLoading?: boolean;
};

export const NoTools = ({ onAddClick, isLoading = false }: NoToolsProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Card className="border-none p-0 shadow-none">
        <CardContent className="flex flex-col items-center justify-center py-12">
          <Skeleton className="mb-6 h-20 w-20 rounded-full" />
          <Skeleton className="mb-2 h-7 w-40" />
          <Skeleton className="mb-2 h-5 w-80" />
          <Skeleton className="mb-8 h-5 w-72" />
          <Skeleton className="h-10 w-28 rounded-md" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-none p-0 shadow-none">
      <CardContent className="flex flex-col items-center justify-center py-12">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-muted">
          <Wrench className="h-10 w-10 text-muted-foreground" />
        </div>

        <h3 className="mb-2 text-xl font-semibold">{t('NO_TOOLS_YET')}</h3>

        <p className="mb-8 text-center text-base leading-relaxed text-muted-foreground">
          {t('NO_TOOLS_DESCRIPTION')}
        </p>

        {onAddClick && <Button onClick={onAddClick}>{t('ADD_TOOL')}</Button>}
      </CardContent>
    </Card>
  );
};
